(function () {
  function applyPresaleOverride() {
    if (typeof VariantSelects === 'undefined') return;

    var originalToggleAddButton = VariantSelects.prototype.toggleAddButton;

    VariantSelects.prototype.toggleAddButton = function (disable, text, modifyClass) {
      if (modifyClass === undefined) modifyClass = true;
      originalToggleAddButton.call(this, disable, text, modifyClass);

      // Only apply presale logic to elements marked with data-presale
      if (!this.dataset.presale) return;
      // Skip the transient loading state (called with modifyClass=false at start of onVariantChange)
      if (modifyClass === false) return;
      // No valid variant combination selected
      if (!this.currentVariant) return;

      var sectionId = this.dataset.presale;
      _applyPresaleButtonState(sectionId, this.currentVariant.id, this.currentVariant.available);
    };

    // Handle Notify Me button clicks: intercept and delegate to the hidden modal opener
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="add"][data-presale-state="notify_me"]');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var form = btn.closest('product-form');
      if (!form || !form.dataset.presale) return;
      var notifyWrapper = document.getElementById('notify-button-' + form.dataset.presale);
      var modalOpenerBtn = notifyWrapper && notifyWrapper.querySelector('.notify-open-button');
      if (modalOpenerBtn) modalOpenerBtn.click();
    }, true); // use capture to run before product-form.js handlers

    // Apply initial presale state from server-rendered HTML
    document.querySelectorAll('[data-presale]').forEach(function (variantRadiosEl) {
      var sectionId = variantRadiosEl.dataset.presale;
      var form = document.getElementById('product-form-' + sectionId);
      var input = form && form.querySelector('[name="id"]');
      if (!input) return;
      var variantId = parseInt(input.value, 10);
      var isAvailable = !input.disabled;
      _applyPresaleButtonState(sectionId, variantId, isAvailable);
    });
  }

  function _applyPresaleButtonState(sectionId, variantId, variantAvailable) {
    var presaleDataEl = document.getElementById('PresaleVariantData-' + sectionId);
    if (!presaleDataEl) return;

    var presaleData = JSON.parse(presaleDataEl.textContent);
    var vData = presaleData.find(function (v) { return v.id === variantId; });

    var form = document.getElementById('product-form-' + sectionId);
    var addButton = form && form.querySelector('[name="add"]');
    var addButtonText = addButton && addButton.querySelector('span');
    var notifyWrapper = document.getElementById('notify-button-' + sectionId);

    if (!addButton || !addButtonText) return;

    var isTracked = vData && vData.im === 'shopify';
    var isOutOfStock = vData ? vData.iq <= 0 : false;

    if (isTracked && isOutOfStock) {
      if (variantAvailable) {
        // Preorder: button enabled, submits cart normally
        addButton.removeAttribute('disabled');
        addButton.removeAttribute('aria-disabled');
        addButton.dataset.presaleState = 'preorder';
        addButtonText.textContent = (window.variantStrings && window.variantStrings.preorder) || 'Preorder';
        if (notifyWrapper) notifyWrapper.style.display = 'none';
      } else {
        // Notify Me: button enabled for click but aria-disabled prevents form submit
        addButton.removeAttribute('disabled');
        addButton.setAttribute('aria-disabled', 'true');
        addButton.dataset.presaleState = 'notify_me';
        addButtonText.textContent = (window.variantStrings && window.variantStrings.notifyMe) || 'Avvisami';
        if (notifyWrapper) notifyWrapper.style.display = 'none'; // modal triggered via main button click
      }
    } else {
      // Standard add to cart
      addButton.dataset.presaleState = 'add_to_cart';
      if (notifyWrapper) notifyWrapper.style.display = 'none';
    }

    // Toggle badge visibility in the sticky bar.
    // Strip "floated-" prefix: FloatedForm rewrites sectionId to "floated-{id}"
    // but the badge element retains the original section id.
    var badgeSectionId = sectionId.replace(/^floated-/, '');
    var badgeEls = document.querySelectorAll('[id="presale-badge-' + badgeSectionId + '"]');
    badgeEls.forEach(function (badgeEl) {
      if (isTracked && isOutOfStock && variantAvailable) {
        badgeEl.classList.remove('hidden');
      } else {
        badgeEl.classList.add('hidden');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPresaleOverride);
  } else {
    applyPresaleOverride();
  }
})();
